import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconPayoutSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest}  width="18.502" height="18.502" viewBox="0 0 18.502 18.502"
             className={classNames(['svg-icon svg-payout', className])}>
                <path d="M0,0H18.5V18.5H0Z" fill="none"/>
                <path fill={color}
                      d="M15.876,4H3.542A1.53,1.53,0,0,0,2.008,5.542L2,14.793a1.537,1.537,0,0,0,1.542,1.542H15.876a1.537,1.537,0,0,0,1.542-1.542V5.542A1.537,1.537,0,0,0,15.876,4Zm-.771,10.793H4.313a.773.773,0,0,1-.771-.771V10.167H15.876v3.855A.773.773,0,0,1,15.106,14.793Zm.771-7.709H3.542V6.313a.773.773,0,0,1,.771-.771H15.106a.773.773,0,0,1,.771.771Z"
                      transform="translate(-0.458 -0.916)"/>
            </svg>

    );
};

IconPayoutSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconPayoutSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconPayoutSVG;